// Generated by ReScript, PLEASE EDIT WITH CARE

import * as MenuActionsTsx from "./MenuActions.tsx";

let make = MenuActionsTsx.Section;

let Section = {
  make: make
};

let make$1 = MenuActionsTsx.Submenu;

let Submenu = {
  make: make$1
};

let make$2 = MenuActionsTsx.Item;

let Item = {
  make: make$2
};

let make$3 = MenuActionsTsx.MenuActions;

export {
  Section,
  Submenu,
  Item,
  make$3 as make,
}
/* make Not a pure module */
